import PropTypes from "prop-types";
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Transition from "./Transition";
import WarningIconSvg from "../../images/icons/warningIcon.svg";
import _ from "lodash";
import { withStyles } from "@material-ui/core";
import LayoutContainer from "../../containers/Layout";
import FormTextArea from "../form/FormTextArea";
import FormComponent from "../FormComponent";
import AuthUserContainer from "../../containers/AuthUser";

const styles = {
  warningIcon: {
    display: "inline-block",
    width: 60,
    height: 60,
    backgroundImage: `url('${WarningIconSvg}')`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    verticalAlign: "middle",
    marginRight: 5,
    marginLeft: 0,
    marginTop: 6,
    padding: 10,
    paddingRight: 20,
  },
  title: {
    lineHeight: 1.2,
    fontSize: 30,
    display: "inline-block",
    verticalAlign: "middle",
    paddingLeft: 5,
    paddingTop: 5,
  },
  logoutButton: {
    padding: `20px 65px`,
    margin: 10,
    fontSize: 20,
    fontWeight: 800,
  },
  continueButton: {
    padding: `20px 65px`,
    margin: 10,
    fontSize: 16,
  },
  dialogRoot: {
    //overflow: 'visible'
    alignItems: "end",
  },
  contentMessage: {
    lineHeight: 2,
    fontSize: 24,
  },
  countdown: {
    padding: 20,
    display: "block",
    paddingTop: 20,
    marginTop: 20,
    borderTop: "1px solid #eee",
    fontSize: "120%",
  },
};

class ShortShiftConfirmationDialog extends FormComponent {
  handleRequestClose = () => {
    this.props.onClose();
  };

  handleConfirm = () => {
    const { onConfirm, showErrors } = this.props;
    const { formFieldError } = this.state;

    const requiredFields = [{ path: "reason", label: "Reason" }];

    requiredFields.forEach(({ path, label }) => {
      if (!this.state[path]) {
        formFieldError[path] = `${label} is required`;
      }
    });

    //- Get all the values and do individual checks
    if (_.keys(formFieldError).length) {
      this.setState({ formFieldError });
      showErrors(_.values(formFieldError));
      return;
    }
    onConfirm({ reason: this.state.reason });
    this.props.onClose();
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        onClose={this.handleRequestClose}
        fullWidth={true}
        maxWidth={"md"}
        classes={{ scrollPaper: classes.dialogRoot }}
      >
        <DialogTitle>
          <div style={{ display: "flex", padding: 30 }}>
            <div className={classes.warningIcon} />
            <span className={classes.title}>
              Wait! You are trying to clock out and your shift is less than 5
              minutes. Are you sure?
            </span>
          </div>
        </DialogTitle>
        <DialogContent>
          If you do need to clock out, leave a note so your supervisor knows why
          you had a short shift
          <FormTextArea
            {...this.setForm("reason", "Reason for short shift", true)}
            rows={2}
          />
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-start", padding: 30 }}>
          <Button
            onClick={this.handleConfirm}
            color="primary"
            variant="outlined"
            size="large"
            className={classes.logoutButton}
          >
            Yes, I need to clock out.
          </Button>

          <Button
            onClick={this.handleRequestClose}
            color="primary"
            variant="outlined"
            aria-label="continue"
            size="large"
            className={classes.continueButton}
          >
            My mistake, cancel.
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ShortShiftConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default _.flow([
  LayoutContainer,
  AuthUserContainer,
  withStyles(styles, { withTheme: true }),
])(ShortShiftConfirmationDialog);
